import styled from 'styled-components';
import { FiUpload, FiX } from 'react-icons/fi';

export const Container = styled.div`
  width: 100%;
`;

export const ContainerUpload = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  border: 2px dotted #1a1d39;
  border-radius: 5px;
  padding: 10px 0;
  cursor: pointer;

  p {
    font-size: 1rem;
    font-weight: 700;
    color: #444444;
  }
`;

export const UploadIcon = styled(FiUpload)`
  color: #1a1d39;
  padding-left: 20px;
  margin-right: 10px;
  cursor: pointer;
`;

export const FileField = styled.input`
  display: none;
`;

export const ContainerInfoFile = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-top: 15px;
`;

export const NameFile = styled.div`
  color: #008000;
  text-overflow: ellipsis;
  max-width: 180px;
  overflow: hidden;
  white-space: nowrap;
`;

export const CloseIcon = styled(FiX)`
  color: #1a1d39;
  cursor: pointer;
`;

export const ErrorContainer = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: start;
  align-items: center;
`;

export const Error = styled.span`
  color: #ce4242;
  font-size: 0.8rem;
  font-weight: 600;
`;
